import { useState } from 'react';

export function useHoverSide() {
  const [hoveredSide, setHoveredSide] = useState<'left' | 'right' | null>(null);

  const handleLeftArrowHover = () => setHoveredSide('left');
  const handleRightArrowHover = () => setHoveredSide('right');
  const handleArrowLeave = () => setHoveredSide(null);

  const handleSlideMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    setHoveredSide(x < rect.width / 2 ? 'left' : 'right');
  };

  return {
    hoveredSide,
    handleLeftArrowHover,
    handleRightArrowHover,
    handleArrowLeave,
    handleSlideMouseMove
  };
}
